/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-05 20:09:14
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2024-06-14 14:07:52
 * FilePath     :\AV-COM-user-backend\src\utils\util.js
 * RevisionHistory:
 */
// vxe-table滚动条是否触底
export function iScrollBottom(e) {
    const scrollEle = e.$event.srcElement
        ? e.$event.srcElement
        : e.$event.target;
    const isTobotomm =
        Math.ceil(scrollEle.scrollTop) + scrollEle.offsetHeight >=
        scrollEle.scrollHeight;
    console.log("[ isTobotomm ] >", isTobotomm);
    return isTobotomm;
}

// 一般防抖 无论触发几次，只算最后一次
export function debounce(fn, delay) {
    // 维护一个 timer
    let timer = null;

    return function () {
        // 通过 ‘this’ 和 ‘arguments’ 获取函数的作用域和变量
        const context = this;
        const args = arguments;

        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
        console.log("Debounced function called");
    };
}

function theParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}
// 获取当前语言
export function currentLang() {
    const supportedLanguages = [
        "de",
        "fr",
        "es",
        "en",
        "it",
        "jp",
        "tw",
        "cn",
        "pt",
    ];
    const segments = theParam("lang");
    let lang = segments;
    if (window.location.host === "www.anyviewer.cn") {
        lang = "cn";
    }
    return supportedLanguages.includes(lang) ? lang : "en";
}
